import PropTypes from 'prop-types';

const patientHighRiskReasonPropType = PropTypes.shape({
    id: PropTypes.number,
    reason: PropTypes.string,
    patientId: PropTypes.string,
});

export default patientHighRiskReasonPropType;
